import React, { useCallback } from "react";
import ProductForm from "../components/ProductForm";
import _ from "lodash";
import { connect } from "react-redux";
import {
  isSubmittingProduct,
  getSubmitProductFailure,
  actions
} from "../modules/market";

const CreateProduct = connect(
  state => ({
    submittingProduct: isSubmittingProduct(state),
    failSubmitProduct: getSubmitProductFailure(state),
    dealer: state.dealers.currentDealer
  }),
  {
    createProduct: actions.createProduct
  }
)(
  ({
    submittingProduct,
    failSubmitProduct,
    createProduct,
    history,
    dealer
  }) => {
    const onSubmit = useCallback(
      async values => {
        const data = {
          product: _.pick(values, [
            "name",
            "description",
            "price",
            "images",
            "has_tax"
          ])
        };
        data.product.category_products_attributes = values.categories.map(
          c => (
            {"category_id": c.id}
          )
        );
        data.product.variants_attributes = values.variants;
        const result = await createProduct({ dealer_id: dealer.id, data });
        if (result.response) {
          history.push("/products");
        }
      },
      [createProduct, dealer.id, history]
    );
    return (
      <div>
        <h3>
          <b>Create Product</b>
        </h3>
        <ProductForm
          submittingProduct={submittingProduct}
          failSubmitProduct={failSubmitProduct}
          onSubmit={onSubmit}
          action='create'
        />
      </div>
    );
  }
);

CreateProduct.displayName = "CreateProduct";

export default CreateProduct;
